import { render, staticRenderFns } from "./bankrupt.vue?vue&type=template&id=26c791e8&scoped=true&"
import script from "./bankrupt.vue?vue&type=script&lang=js&"
export * from "./bankrupt.vue?vue&type=script&lang=js&"
import style0 from "./bankrupt.vue?vue&type=style&index=0&id=26c791e8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26c791e8",
  null
  
)

export default component.exports